export const apiPath = '/v2/contacts';
const actionType = 'CONTACTS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
